import { useState } from 'react';
import { ShoppingCart } from 'lucide-react';
import CartDropdown from '../CartDropdown';

interface CartButtonProps {
  itemCount: number;
}

/** Desktop cart icon with badge count and dropdown */
export function CartButton({ itemCount }: CartButtonProps) {
  const [isCartOpen, setIsCartOpen] = useState(false);

  return (
    <div className="relative">
      <button
        onClick={() => setIsCartOpen(!isCartOpen)}
        className="text-jme-purple hover:text-purple-700 transition-all duration-300 transform hover:scale-110 hover:rotate-3 relative"
        aria-label={`Shopping cart${itemCount > 0 ? `, ${itemCount} item${itemCount === 1 ? '' : 's'}` : ', empty'}`}
        aria-expanded={isCartOpen}
      >
        <ShoppingCart className="w-5 h-5" />
        {itemCount > 0 && (
          <span className="absolute -top-2 -right-2 bg-gradient-to-r from-jme-purple to-purple-600 text-white text-xs w-5 h-5 rounded-full flex items-center justify-center animate-pulse shadow-md">
            {itemCount}
          </span>
        )}
      </button>

      {/* Cart Dropdown */}
      {isCartOpen && (
        <CartDropdown onClose={() => setIsCartOpen(false)} />
      )}
    </div>
  );
}
